import React from 'react';
import ApplyNew from '../components/apply-new';

const ApplyNewPage = () => {
  return <ApplyNew />;
};

export default ApplyNewPage;
